<script lang="ts" setup>
import { useCommonStore } from '@stores/common'
import { useCheckoutStore } from '@stores/checkout'

import { AppLogoDomain } from '@UI/Logos/AppLogoDomain'
import ButtonBack from '@Widgets/Orders/Checkout/ButtonBack.vue'
import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'
import { LoaderOverlay } from '@UI/Loaders/LoaderOverlay'

defineOptions({
  name: 'LayoutCheckout',
})

const commonStore = useCommonStore()
const checkoutStore = useCheckoutStore()

</script>

<template>
  <div class="cs-checkout">
    <ButtonBack />
    <div class="cs-checkout__main">
      <div class="cs-checkout__header">
        <AppLogoDomain />
      </div>
      <div class="cs-checkout__general">
        <div class="cs-checkout__content">
          <slot />
        </div>
        <div class="cs-checkout__links">
          <slot name="links" />
        </div>
      </div>
    </div>
    <div class="cs-checkout__form">
      <div
        v-if="commonStore.isLoading"
        class="cs-checkout__skeleton"
      >
        <div class="cs-checkout__pseudo-header" />
        <div class="cs-checkout__loader">
          <LoaderBlockDomain />
        </div>
      </div>
      <template v-else>
        <div class="cs-checkout__form-content">
          <slot name="form" />
        </div>
        <div class="cs-checkout__badges">
          <slot name="badges" />
        </div>
        <div class="cs-checkout__policy mobile">
          <slot name="policy" />
        </div>
      </template>
      <LoaderOverlay v-if="checkoutStore.isLoading" />
    </div>
  </div>
  <slot
    v-if="$slots.modals"
    name="modals"
  />
</template>

<style scoped lang="scss" src="@scss/layouts/checkout.scss" />
